import { DrawingActions, IToolbarDrawingAction, IToolbarDrawingActionItem } from './interfaces'

export const drawingActions: Record<DrawingActions, IToolbarDrawingAction> = {
  [DrawingActions.DeleteDrawings]: {
    id: DrawingActions.DeleteDrawings,
    title: 'Remove all drawings',
    icon: 'drawingActionDelete',
  },
}

export const toolbarDrawingActions: Array<IToolbarDrawingActionItem> = [
  {
    defaultItem: drawingActions[DrawingActions.DeleteDrawings],
  },
]
